var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.decisionDenied)?_c('DeniedView'):_c('SupplementingView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }